<template>
  <v-card class="docs serviceCZN">
    <v-card-title>
      <div class="text-h5 text-center">{{ service['name'] }}</div>
    </v-card-title>
    <div class="subheader">{{ getCategoryText(service['category']) }}</div>
    <table class="docs-table" v-if="serviceId != null && services != null">
      <tbody>
      <tr v-if="edit">
        <td>
          Категория сервиса
        </td>
        <td>
          <v-autocomplete
              :items="categories"
              v-model="service['category']"
              item-value="value"
              item-text="text"
          ></v-autocomplete>
        </td>
      </tr>
      <template v-for="(section, sectionId) in getFieldSections()">
        <tr :key="'title'+sectionId">
          <td colspan="2" style="font-weight: 600; background-color: #FCF4DB; padding-top: 25px">
            {{ section || 'Иные сведения' }}
          </td>
        </tr>
        <tr v-for="(field, fieldIndex) in getFilteredFieldsBySection(section)"
            :key="'field_' + sectionId +'_'+ fieldIndex">
          <template v-if="field.id !== 'category'">
            <td>
              {{ field.name }}
            </td>
            <td>
              <template v-if="edit">

                <v-text-field v-if="field.type==='NUMBER'" type="number"
                              v-model="service[field.id]"></v-text-field>
                <date-field v-else-if="field.type==='DATE'" :date-value="service[field.id]"
                            @minput="updateDateField(field.id, $event)"></date-field>

                <v-autocomplete
                    v-else-if="field.type?.startsWith('dict_')"
                    :items="getDict(field.type)"
                    v-model="service[field.id]"
                    :multiple="field.multiple"
                ></v-autocomplete>

                <template v-else-if="field.type==='FILES'">
                  <p v-for="file in service[field.id]" :key="file.id">
                    <a :href="'/uuidfs/' + file.id" @click.prevent="downloadFile(file.id, file.name)">
                      {{ truncateStr(file.name, 30) }}
                    </a>
                    <a @click="deleteFile(file.id, field.id)" v-if="$user != null && edit">
                      <v-icon>mdi-window-close</v-icon>
                    </a>
                  </p>
                  <input type="file" multiple :ref="'fileupload_'+field.id" style="display:none"
                         @change="addFiles($event.target.files, field.id)">
                  <a @click="$refs['fileupload_'+field.id][0].click()" class="upload-link"><i>Добавить файлы</i></a>
                </template>
                <v-text-field v-else v-model="service[field.id]"></v-text-field>
              </template>
              <template v-else>
                <template v-if="field.type==='LINK'">
                  <a :href="service[field.id]" target="_blank">{{ service[field.id] }}</a>
                </template>
                <template v-else-if="field.type==='FILES'">
                  <p v-for="file in service[field.id]" :key="file.id">
                    <a :href="'/uuidfs/' + file.id" @click.prevent="downloadFile(file.id, file.name, service)">
                      {{ truncateStr(file.name, 30) }}
                    </a>
                  </p>
                </template>
                <template v-else-if="field.type?.startsWith('dict_') && field.multiple">
                  <p v-for="(v, vi) in service[field.id]" :key="'opt'+serviceId+'_'+field.id+'_'+vi">- {{v}}</p>
                </template>
                <template v-else-if="field.type==='DATE'">
                  {{ service[field.id] | dateFormat }}
                </template>
                <template v-else>
                  {{ service[field.id] }}
                </template>
              </template>
            </td>
          </template>
        </tr>
      </template>
      </tbody>
    </table>


    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          class="btn btn-outline"
          text
          @click="$emit('close')"
      >
        Закрыть
      </v-btn>
      <v-btn
          v-if="$user != null && ['ROLE_ADMIN', 'ROLE_VNII'].includes($user.role) && edit===false"
          class="btn btn-primary"
          @click="edit=true"
      >
        Редактировать
      </v-btn>
      <v-btn
          v-if="edit===true"
          class="btn btn-primary"
          @click="submit()"
      >
        Сохранить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {categories, getCategoryText, saveServices, truncateStr, uploadFile} from "@/modules/services";
import api from "@/modules/api";
import DateField from "@/components/elements/DateField";

export default {
  name: 'EditDialog',
  components: {DateField},
  props: {
    services: Array,
    serviceId: String,
    config: Object
  },

  data: () => ({
    edit: false,
    categories: categories
  }),
  computed: {
    service() {
      return this.services.find(e => e.id === this.serviceId) ?? {}
    }
  },
  methods: {
    getCategoryText: getCategoryText,
    truncateStr: truncateStr,

    updateDateField(fieldId, value) {
      this.$set(this.service, fieldId, value);
    },

    filteredFields() {
      const filterCat = this.service['category']
      if (filterCat) {
        return this.config.fields.filter(e => e.categories?.includes(filterCat))
      } else {
        return this.config.fields
      }
    },

    getFieldSections() {
      let sections = []
      let fields = this.filteredFields()
      for (let field of fields) {
        if (!sections.includes(field.section)) {
          sections.push(field.section)
        }
      }
      return sections
    },

    getFilteredFieldsBySection(section) {
      const filteredFields = this.filteredFields().filter(e => e.section === section);
      
      if (!this.$user) {
        return filteredFields.filter(e => e.public);
      }
      
      return filteredFields;
    },

    getDict(id){
      return this.config.dicts?.find(e=>e.id===id)?.values
    },

    async submit() {
      await saveServices(this.services)
      this.$emit('close')
    },

    async addFiles(files, fieldId) {
      if (!this.service[fieldId]) {
        this.service[fieldId] = []
      }

      for (let file of files) {
        let uploadRes = await uploadFile(file)
        if (uploadRes) {
          this.service[fieldId].push(uploadRes)
        } else {
          alert('Ошибка загрузки файла')
        }
      }
      console.log(this.service)
      this.$forceUpdate()
    },

    async downloadFile(fileId, fileName) {
      let req = await api.download("/s3/" + fileId, {});
      if (req.ok) {
        let link = document.createElement('a');
        link.href = URL.createObjectURL(req.payload);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
        if(api.token != null) {
          this.service.downloadsCount = Number(this.service.downloadsCount || 0) + 1;
          await saveServices(this.services)
        }
      } else {
        console.log('download error');
      }
    },

    async deleteFile(fileId, fieldId) {
      for (let i = 0; i < this.service[fieldId].length; i++) {
        if (this.service[fieldId][i].id === fileId) {
          this.service[fieldId].splice(i, 1)
          this.$forceUpdate()
          break
        }
      }
    }

  },
  filters: {
    dateFormat: function (date) {
      if (date == null || date === '') {
        return ''
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    },
  },
  beforeMount() {
  }
}
</script>


